export class MessageNotification {
    constructor(
        public subject?: string,
        public body?: string,
        public relatedEntityId?: number,
        public messageType?: string
    ) {
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.message.model.ts